module.exports = __webpack_public_path__ + "static/media/mshtml_32537.1411538f.ico";